import styled from 'styled-components';
import media from '../../../styles/Media.styled';

export const MessageHeader = styled.div`
    height: 30px;
    font-size: 17px;
    margin-left: 4px;
    color:${(props) => props.color ? props.color :'#202124'};
    font-family: AvenirNextWorld Demi;
    width: 43%;
    padding-left: 10px;
    padding-right: 28px;
    ${media.largeDevice`
        width: 55%;
    `}
    ${media.mediumDevice`
        width: 68%;
    `}
    ${media.smalDevice`
        width: 100%;
    `}
    ${media.mobileDevice`
        text-align: ${({ textAlign }) => (textAlign ? textAlign : 'center')};
        height: auto;
        width: 100%;
        padding-top: 5px;
        white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : '')};
      //  margin-left:20px;
        margin-right:20px;
    `}
    ${media.exSmallDevice`
        width: 100%;
    `}
`;

export const MessageContainer = styled.div`
    font-size: 14px;
    margin-left: 4px;
    color: #202124;
    font-family: AvenirNextWorld Regular;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    ${media.mobileDevice`
        text-align: ${({ textAlign }) => (textAlign ? textAlign : 'center')};
        padding-top: 5px;
        font-size: 12px;
    `}
`;

export const MessageIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 56px;
    background: ${(props) => props.background};
    box-shadow: 0px 3px 6px #00000029;
    padding: 0 10px;
    border-radius: 6px 0px 0px 6px;

    ${media.mobileDevice`
        padding: 0 ;
        margin-top: ${({ mbMarginTop }) =>
            mbMarginTop ? mbMarginTop : '36px'};
    `}
`;

export const MessageContent = styled.div`
    background: #ffffff 0% 0% no-repeat;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 0px 6px 6px 0px;
    width: 95%;
    padding: 5px 0 7px 0;
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    ${media.mobileDevice` 
        width : 100%;
        margin-top: ${({ mbMarginTop }) =>
            mbMarginTop ? mbMarginTop : '36px'};
    `}
`;

export const Flex = styled.div`
    display: flex;
    margin-top: ${(props) => props.marginTop};
    margin-bottom: ${(props) => props.marginBottom};
    ${media.mobileDevice`
        margin-top:0px;
        margin-left: 5px;
         margin-right:10px;
    `}

    @media only screen and (min-width: 390px) and (max-width: 395px) {
        margin-left: ${({ marginLeft }) =>
            marginLeft === '5' ? '6px' : marginLeft === '6px' && '8px'};
        margin-right: ${({ marginRight }) => marginRight === '10px' && '5px'};
    }
    @media only screen and (min-width: 375px) and (max-width: 377px) {
        margin-left: ${({ marginLeft }) =>
            marginLeft === '5' ? '5px' : marginLeft === '6px' && '6px'};
        margin-right: ${({ marginRight }) => marginRight === '10px' && '10px'};
    }

    @media only screen and (min-width: 430px) and (max-width: 435px) {
        margin-left: ${({ marginLeft }) =>
            marginLeft === '5' ? '6px' : marginLeft === '6px' && '8px'};
        margin-right: ${({ marginRight }) => marginRight === '10px' && '5px'};
    }
`;
